import { useEffect } from 'react'
import { SelectInput, TextInput, required } from 'react-admin'
import { Grid } from '@mui/material'
import { useWatch, useFormContext } from 'react-hook-form'
import { BOOKINGVIEW_FIELDS as BOOKING_FIELDS } from '../../../providers/localization/constant'

export const CancelReasonInput = (): JSX.Element => {
  const { unregister } = useFormContext()
  const statusField = useWatch({ name: 'status' })
  const cancelStatus = 'cancel'
  const reasonChoices = useWatch({ name: 'cancel_reason_choices' })
  const otherReason = 'other'

  useEffect(() => {
    if (statusField !== cancelStatus) {
      unregister('cancel_reason')
    }
  }, [cancelStatus, statusField, unregister])

  const validator = {
    validate: [required()],
  }

  if (!statusField) return null

  return statusField === cancelStatus ? (
    <Grid container>
      <Grid item xs={12}>
        <SelectInput
          source='cancel_reason_choices'
          label={`${BOOKING_FIELDS}.cancel_reason`}
          choices={[
            { id: 'out_of_stock', name: 'สินค้าขาดตลาด' },
            { id: 'inconvenient', name: 'ลูกค้าไม่สะดวกเข้ารับบริการ' },
            { id: 'other', name: 'อื่นๆ' },
          ]}
          {...(statusField === cancelStatus ? validator : '')}
          fullWidth
        />
      </Grid>
      {reasonChoices === otherReason && (
        <Grid item xs={12}>
          <TextInput
            source='cancel_reason'
            label={`${BOOKING_FIELDS}.other_reason`}
            multiline
            rows={3}
            {...(reasonChoices === otherReason ? validator : '')}
            fullWidth
          />
        </Grid>
      )}
    </Grid>
  ) : null
}
